module.exports = __webpack_public_path__ + "static/img/2.2cdbf53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/snip3down/2.png
// module id = hbva
// module chunks = 35